var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e8dcff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud_3",
    "data-name": "cloud 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251,409.21c36-17.41,77.72-11.38,114.65,3.38s70.93,37.68,107.13,54.63,76.43,27.89,114.4,17.12C650.29,466.44,697,392,762,391.35c41.63-.44,77.89,30,112.34,56.76s75.61,52,115.85,39.76c39.6-12,64.06-55.74,94.7-86.85,54.52-55.36,137.15-68.8,204.59-38.76,14.19,6.32,12.76,26.74-2.06,31.4-30.5,9.59-58.75,33.92-79.56,62.18-31.5,42.77-52,94.87-82.59,138.47s-77.18,79.7-125.46,70.78C937,653.49,899.61,573.21,838.41,553.52c-55.91-18-112.78,19.21-162.38,53.78s-108.71,69.11-163.17,46c-41.29-17.52-67.13-63.38-100.71-96C368,514.55,307.51,496,250.38,504.4c-22.77,3.36-55.92,16.66-52.56-25.23C200.26,448.79,228.09,420.28,251,409.21Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects17);
export default __webpack_public_path__ + "static/media/objects-17.09aef930feb3d549b3f3eb78c0322d7f.svg";
export { ForwardRef as ReactComponent };